import { version as VERSION } from '../package.json';

export const version = VERSION;
export {
  getTrackingDispatchers,
  addTrackingReducerConnection,
  getTrackingReducerConnection,
  type EventApp,
  type TrackingEvent,
} from './connections/aem-tracking';
